import { createContext } from "react";
import { LayoutContextType } from "./type";

const defaultValue: LayoutContextType = {
  isSidebarOpen: false,
  setIsSidebarOpen: () => {},
  rightPanelWidth: 0,
  setRightPanelWidth: () => {},
  isNucleusExpanded: false,
  setIsNucleusExpanded: () => {},
  isComparing: false,
  setIsComparing: () => {},
};

export const LayoutContext = createContext(defaultValue);
